import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {
  location: any;
  Store: any;
  Dispatch: any;
  back: any;
  next: any;
}

interface StateInterface {
  step: number;
}

class Default extends React.Component<PropsInterface> {
  public render() {
    return (
      <>
        <h2>Выбираем продолжительность встречи</h2>
        <button
          onClick={() => {
            console.log("PUSH NEXT")
            this.props.next();
          }}
        >
          Далее
        </button>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
